import { useState, useEffect } from 'react';
import { FinanceService } from '../../../core/services/FinanceService';

interface Props {
    idSelector: number;
    onChange: any;
    titulo?: string;
}

export const SelectBudgetStrcutureCatalog = ({ idSelector, onChange, titulo }: Props) => {

    const service = new FinanceService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(idSelector ?? 0);

    useEffect(() => {
        setID(idSelector);
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        service.getBudgetStructureCatalog(null).subscribe(
            (resp: any) => {
                setLista([]);
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
            }
        );
    }

    return (
        <>
            <label>{titulo ?? "Tipo de Estructura"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any, _i) => {
                        return (
                            <option key={_i} value={item.DataBeanProperties.IDBudgetStructure} >{item.DataBeanProperties.IDBudgetStructure} - {item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}